import { Suspense, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import ResumenFiltrosComponent from '../components/resumenFiltrosComponent';
import ResumenTotalesComponent from '../components/resumenTotalesComponent';
import ResumenVisadosComponent from '../components/resumenVisadosComponent';
import { useValidadorAsientosContablesContext } from '../../../../context/validadorAsientosContablesContext';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';

const breadcrumbItems = [
    { label: 'Contabilidad', url: '/contabilidad' },
    { label: 'Validador de Asientos', url: '/contabilidad/validadorAsientos' },
    { label: 'Analizar movimientos contables', active: true },
]

function AnalizarMovimientosContables() {

    const navigate = useNavigate();
    const { formFilters, totalesMovimientosContables, getTotalesMovimientosContables } = useValidadorAsientosContablesContext();

    useEffect(() => {
        if( !formFilters ) return;
        getTotalesMovimientosContables();
    }, [formFilters, navigate]);

    return (
        <>
            <Suspense>
                <Breadcrumb items={ breadcrumbItems } />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            { totalesMovimientosContables != null && (
                                <>
                                    <ResumenFiltrosComponent />
                                    <ResumenTotalesComponent />
                                    <ResumenVisadosComponent />
                                </>
                            ) }
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
};

export default AnalizarMovimientosContables;